import React from 'react';
import { SectionTitle } from './SectionTitle';
import { CTAButton } from './CTAButton';
import { modules } from '../data/salesCopy';
export function ModulesSection() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-102" data-mp="1ivl15yyoiyoi">
      <div className="mx-auto max-w-3xl" data-id="element-103" data-mp="1iw375nb58r9m">
        <SectionTitle data-id="element-104" data-mp="1dwqhkusw163c">Ce qui est inclus</SectionTitle>

        <div className="mt-5 space-y-2.5" data-id="element-105" data-mp="1dy1jep2rw3rt">
          {modules.map(mod => <article key={mod.n} className="overflow-hidden rounded-lg border border-brand-sand bg-white shadow-sm" data-id="element-106" data-mp="2bixmk5t3t0g8">
              <header className="flex items-center gap-2 bg-brand-sage px-3 py-2 sm:px-4" data-id="element-107" data-mp="21lsxny7viqvq">
                <span className="shrink-0 rounded bg-brand-gold px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white" data-id="element-108" data-mp="1wmzw945v2qbx">
                  Module {mod.n}
                </span>
                <h3 className="font-serif text-base font-bold uppercase leading-tight text-white sm:text-xl" data-id="element-109" data-mp="l7t0uw4brhcp">
                  {mod.title}
                </h3>
              </header>

              <div className="space-y-2 p-3 sm:p-4" data-id="element-110" data-mp="1it5pqhwn4fkg">
                {mod.paras.map(p => <p key={p} className="text-[12.5px] font-medium leading-snug text-brand-brown/85 sm:text-[13.5px]" data-id="element-111" data-mp="1ns8xia408zw4">
                    {p}
                  </p>)}
                <p className="border-t border-brand-sand pt-2 text-[12.5px] font-bold uppercase leading-snug tracking-wide text-brand-taupe sm:text-[13.5px]" data-id="element-112" data-mp="1047hyh8esj77">
                  {mod.close}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-5 flex justify-center" data-id="element-113" data-mp="v5nv8elzr3ds">
          <CTAButton data-id="element-114" data-mp="v6ftxyavxh8a">🧘 Oui ! Je veux le système complet</CTAButton>
        </div>
      </div>
    </section>;
}